'use strict';var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}} // Copyright 2015-2017 Parity Technologies (UK) Ltd.
// This file is part of Parity.

// Parity is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.

// Parity is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.

// You should have received a copy of the GNU General Public License
// along with Parity.  If not, see <http://www.gnu.org/licenses/>.

var BigNumber = require('bignumber.js');var

Eth = function () {
  function Eth(updateSubscriptions, api) {var _this = this;_classCallCheck(this, Eth);
    this._api = api;
    this._updateSubscriptions = updateSubscriptions;
    this._started = false;

    this._lastBlock = new BigNumber(-1);
    this._pollTimerId = null;
    this._pollBlockNumber = this._pollBlockNumber.bind(this);

    this._api.provider.on('close', function () {
      if (_this.isStarted) {
        _this.start();
      }
    });
  }_createClass(Eth, [{ key: 'start', value: function start()





    {var _this2 = this;
      this._started = true;

      if (this._api.isPubSub) {
        return Promise.all([
        this._pollBlockNumber(false),
        this._api.pubsub.
        subscribeAndGetResult(
        function (callback) {return _this2._api.pubsub.eth.newHeads(callback);},
        function () {
          return _this2._api.eth.
          blockNumber().
          then(function (blockNumber) {
            _this2.updateBlock(blockNumber);
            return blockNumber;
          });
        })]);


      }

      return this._pollBlockNumber(true);
    } }, { key: '_pollBlockNumber', value: function _pollBlockNumber(

    doTimeout) {var _this3 = this;
      var nextTimeout = function nextTimeout() {var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;var forceTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : doTimeout;
        if (forceTimeout) {
          _this3._pollTimerId = setTimeout(function () {
            _this3._pollBlockNumber(doTimeout);
          }, timeout);
        }
      };

      if (!this._api.provider.isConnected) {
        nextTimeout(500, true);
        return;
      }

      return this._api.eth.
      blockNumber().
      then(function (blockNumber) {
        _this3.updateBlock(blockNumber);

        nextTimeout();
      }).
      catch(function () {return nextTimeout();});
    } }, { key: 'updateBlock', value: function updateBlock(

    blockNumber) {
      if (!blockNumber.eq(this._lastBlock)) {
        this._lastBlock = blockNumber;
        this._updateSubscriptions('eth_blockNumber', null, blockNumber);
      }
    } }, { key: 'isStarted', get: function get() {return this._started;} }]);return Eth;}();


module.exports = Eth;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@parity/api/lib/subscriptions/eth.js
// module id = 439
// module chunks = 0